import { apiGet } from "./client";
import type {
  CmsBlock,
  CmsDocument,
  CmsDocumentSummary,
} from "@ceo-cmd/shared";

export type { CmsBlock, CmsDocument, CmsDocumentSummary };

/** Published documents in a category — summaries for nav and index cards. */
export async function listCmsDocuments(
  category = "help",
): Promise<CmsDocumentSummary[]> {
  const res = await apiGet<{ documents: CmsDocumentSummary[] }>(
    `/api/cms/${encodeURIComponent(category)}`,
  );
  return res.documents ?? [];
}

/** One document plus its sibling index, so nav renders in a single request. */
export async function getCmsDocument(
  slug: string,
  category = "help",
): Promise<{ document: CmsDocument; index: CmsDocumentSummary[] }> {
  return apiGet(
    `/api/cms/${encodeURIComponent(category)}/${encodeURIComponent(slug || "index")}`,
  );
}
